export default __webpack_public_path__ + "static/realWorldImg4-1d035fa877bb490e959f7468f7da6fa1.webp";